/* ==========================================================================
   LensShop — Infinite scroll para colecoes e busca
   Carrega a proxima pagina automaticamente ao chegar perto do fim da lista,
   fazendo APPEND dos produtos (o tema base substitui; aqui acrescentamos).
   Usa o mesmo "section rendering" do tema (?section_id=).
   Degradacao graciosa: sem JS / sem IntersectionObserver, a paginacao
   numerica original continua funcionando normalmente.
   ========================================================================== */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var GRID_SELECTOR = '.product-list--collection';
  var LOAD_MARGIN = '800px 0px';
  var activeObserver = null;

  function setup() {
    var grid = document.querySelector(GRID_SELECTOR + ':not([data-ls-infinite])');
    if (!grid) return;

    var pagination = grid.parentNode.querySelector('.pagination');
    if (!pagination || !pagination.querySelector('.pagination__next')) {
      // uma unica pagina — nada a fazer
      grid.setAttribute('data-ls-infinite', 'done');
      return;
    }

    grid.setAttribute('data-ls-infinite', '1');

    // Desconecta observer de um ciclo anterior (ex.: apos filtrar)
    if (activeObserver) { activeObserver.disconnect(); activeObserver = null; }

    var section = grid.closest('[data-section-id]');
    var sectionId = section ? section.getAttribute('data-section-id') : null;

    pagination.classList.add('ls-infinite-hidden');

    var state = { loading: false, done: false };

    var sentinel = document.createElement('div');
    sentinel.className = 'ls-infinite-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    pagination.parentNode.insertBefore(sentinel, pagination);

    var status = document.createElement('div');
    status.className = 'ls-infinite-status';
    status.setAttribute('aria-live', 'polite');
    pagination.parentNode.insertBefore(status, pagination);

    function nextUrl() {
      var link = pagination.querySelector('.pagination__next');
      return link && link.getAttribute('href') ? link.getAttribute('href') : null;
    }

    function finish() {
      state.done = true;
      if (activeObserver) { activeObserver.disconnect(); }
      if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
      status.innerHTML = '<span class="ls-infinite-end">Voce viu todos os produtos</span>';
    }

    function load() {
      if (state.loading || state.done) return;
      var url = nextUrl();
      if (!url) { finish(); return; }

      state.loading = true;
      status.innerHTML = '<span class="ls-infinite-spinner" aria-hidden="true"></span>';

      var fetchUrl = new URL(url, window.location.origin);
      if (sectionId) fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;

          var newGrid = tmp.querySelector(GRID_SELECTOR);
          if (newGrid) {
            var frag = document.createDocumentFragment();
            var items = newGrid.querySelectorAll('.product-item');
            for (var i = 0; i < items.length; i++) {
              // Revelacao suave escalonada (cascata) ao entrar na grade
              items[i].classList.add('ls-reveal');
              items[i].style.animationDelay = (Math.min(i, 8) * 45) + 'ms';
              frag.appendChild(items[i]);
            }
            grid.appendChild(frag);
          }

          var newPag = tmp.querySelector('.pagination');
          if (newPag) {
            newPag.classList.add('ls-infinite-hidden');
            pagination.parentNode.replaceChild(newPag, pagination);
            pagination = newPag;
          }

          state.loading = false;
          status.innerHTML = '';

          if (!nextUrl()) {
            finish();
          } else {
            // re-avalia a interseccao apos o novo conteudo
            activeObserver.unobserve(sentinel);
            activeObserver.observe(sentinel);
          }
        })
        .catch(function () {
          // Em erro, devolve a paginacao numerica para navegacao manual
          state.loading = false;
          status.innerHTML = '';
          pagination.classList.remove('ls-infinite-hidden');
        });
    }

    activeObserver = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) { load(); }
    }, { rootMargin: LOAD_MARGIN });

    activeObserver.observe(sentinel);
  }

  function boot() { setup(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // O tema recarrega a colecao (filtro/ordenacao/exibicao) via AJAX e
  // dispara este evento ao terminar; re-inicializamos sobre o novo grid.
  document.addEventListener('theme:loading:end', function () {
    setTimeout(setup, 60);
  });
})();
